/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Personal_DescriptionInputs */



/**
* | output |
* | --- |
* | "Things about yourself the assistant should know, like what to call you or your role." |
*
* @param {Memory_Personal_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_personal_description = /** @type {((inputs?: Memory_Personal_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Personal_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was der Assistent über dich wissen soll, z. B. wie er dich ansprechen soll oder deine Rolle.")
	return /** @type {LocalizedString} */ ("Things about yourself the assistant should know, like what to call you or your role.")
});